import { useLocalSearchParams } from "expo-router";
import { useTranslation } from "react-i18next";
import { ActivityIndicator, View } from "react-native";

import { useParentStackTitle } from "@/components/navigation/useParentStackTitle";
import { AbsencesScreen } from "@/features/absences/AbsencesScreen";
import {
    getChildLabel,
    showChildLabels,
    useChildren,
} from "@/features/selectedChild";

export default function ChildAbsencesRoute() {
    const { id } = useLocalSearchParams<{ id: string }>();
    const childId = Number(id);
    const { t } = useTranslation();
    const { children, isLoading } = useChildren();

    const child = children.find((item) => item.id === childId);
    const title = child
        ? showChildLabels(children.length)
            ? getChildLabel(child)
            : t("screens.absences")
        : undefined;

    useParentStackTitle(title);

    if (isLoading) {
        return (
            <View className="flex-1 items-center justify-center bg-background">
                <ActivityIndicator />
            </View>
        );
    }

    if (!child) {
        return null;
    }

    return <AbsencesScreen childId={child.id} />;
}
